var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('fa-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":true,"size":"2x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }